export default __webpack_public_path__ + "static/media/Dirigo.b7e5174f.svg";